/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AutocompleteStats,
    AutocompleteStatsFromJSON,
    AutocompleteStatsFromJSONTyped,
    AutocompleteStatsToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutocompleteStatsResponse
 */
export interface AutocompleteStatsResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof AutocompleteStatsResponse
     */
    msg: string;
    /**
     * 
     * @type {AutocompleteStats}
     * @memberof AutocompleteStatsResponse
     */
    entry: AutocompleteStats;
}

export function AutocompleteStatsResponseFromJSON(json: any): AutocompleteStatsResponse {
    return AutocompleteStatsResponseFromJSONTyped(json, false);
}

export function AutocompleteStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutocompleteStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': AutocompleteStatsFromJSON(json['entry']),
    };
}

export function AutocompleteStatsResponseToJSON(value?: AutocompleteStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': AutocompleteStatsToJSON(value.entry),
    };
}


